module.exports = __webpack_public_path__ + "img/default.5f64ce6d.png";